"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePaymentGateway = void 0;
var inversify_react_1 = require("inversify-react");
var swr_1 = __importDefault(require("swr"));
var axios_1 = __importDefault(require("axios"));
var usePaymentGateway = function () {
    var apiBaseUrl = (0, inversify_react_1.useInjection)("apiBaseUrl");
    var url = "".concat(apiBaseUrl, "/payments/gateway");
    var _a = (0, swr_1.default)([url], function (args) { return fetchPaymentGateways.apply(void 0, __spreadArray([], __read(args), false)); }, {
        revalidateOnFocus: false,
    }), data = _a.data, mutate = _a.mutate;
    function creator(params) {
        return __awaiter(this, void 0, Promise, function () {
            var gateway;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, createPaymentGateway(url, params)];
                    case 1:
                        gateway = _a.sent();
                        return [4, mutate()];
                    case 2:
                        _a.sent();
                        return [2, gateway];
                }
            });
        });
    }
    function updater(id, updates) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, updatePaymentGateway(url, id, updates)];
                    case 1:
                        _a.sent();
                        return [4, mutate()];
                    case 2:
                        _a.sent();
                        return [2];
                }
            });
        });
    }
    function deleter(gatewayId) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, deletePaymentGateway(url, gatewayId)];
                    case 1:
                        _a.sent();
                        return [4, mutate()];
                    case 2:
                        _a.sent();
                        return [2];
                }
            });
        });
    }
    return {
        gateways: data || [],
        creator: creator,
        updater: updater,
        deleter: deleter,
    };
};
exports.usePaymentGateway = usePaymentGateway;
var transformResponse = function (gateway) { return ({
    id: gateway.id,
    countryCode: gateway.platformCountryCode,
    defaultGateway: gateway.defaultGateway,
    name: gateway.name,
    platform: {
        kind: "stripe",
        id: gateway.stripeAccountId,
    },
    settings: gateway.settings,
    status: gateway.status,
}); };
var fetchPaymentGateways = function (url) { return __awaiter(void 0, void 0, Promise, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, axios_1.default.get(url, { withCredentials: true })];
            case 1:
                response = _a.sent();
                return [2, response.data.map(transformResponse)];
        }
    });
}); };
var updatePaymentGateway = function (url, gatewayId, updates) { return __awaiter(void 0, void 0, Promise, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, axios_1.default.patch("".concat(url, "/").concat(gatewayId), __assign({}, updates), { withCredentials: true })];
            case 1:
                _a.sent();
                return [2];
        }
    });
}); };
var deletePaymentGateway = function (url, gatewayId) { return __awaiter(void 0, void 0, Promise, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, axios_1.default.delete("".concat(url, "/").concat(gatewayId), { withCredentials: true })];
            case 1:
                _a.sent();
                return [2];
        }
    });
}); };
var createPaymentGateway = function (url, params) { return __awaiter(void 0, void 0, Promise, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, axios_1.default.post(url, { countryCode: params.countryCode, defaultGateway: params.defaultGateway }, {
                    withCredentials: true,
                })];
            case 1:
                response = _a.sent();
                return [2, transformResponse(response.data)];
        }
    });
}); };
